<template>
	<div class="wrapper ">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>{{article.title}}</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="article">
			<div class="title">
				<h2>{{article.title}}</h2>
				<p>{{article.createTime}}</p>
			</div>
			<div class="content" v-html="article.content">
			</div>
		</div>

	</div>
</template>

<script>
export default {
    name: 'article',
    data() {
        return {
            article: {}
        }
    },
    created() {
        if(this.$route.params.article){
            this.article = this.$route.params.article
        }
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
	.article {
		background: rgba($color: $main-color, $alpha: 0.25);
		border-radius: 10px;
		padding: 20px;
		.title{
			text-align: center;
			border-bottom:1px solid rgba($color: $main-color, $alpha: 0.6);
			padding: 10px 0 20px 0;
			margin: 0 0 20px 0;
			h2{
				margin: 0 0 10px 0;
			}
		}
		.content{
			font-size: 16px;
			line-height: 26px;
			p{
				margin: 0 0 10px 0;
			}
			img{
				display: block;
				max-width: 100%;
				margin: 0 auto 10px;
			}
		}
	}
</style>
